import { useCallback, useEffect, useRef } from 'react'

import { useGetUserQuery, useUpdateUserActivationDataMutation } from 'common'

export const useSpotlightState = () => {
  const { data: { activation_data: { spotlights = {} } = {} } = {} } = useGetUserQuery()

  const [update] = useUpdateUserActivationDataMutation()
  const spotlightsRef = useRef(spotlights)

  useEffect(() => {
    spotlightsRef.current = spotlights
  }, [spotlights])

  const setSpotlights = useCallback((patch) => {
    update({ spotlights: { ...spotlightsRef.current, ...patch } })
  }, [update])

  return [spotlights, setSpotlights]
}
